import { render, staticRenderFns } from "./InfoThreads.vue?vue&type=template&id=5e141cca&scoped=true&lang=pug"
import script from "./InfoThreads.vue?vue&type=script&lang=js"
export * from "./InfoThreads.vue?vue&type=script&lang=js"
import style0 from "./InfoThreads.vue?vue&type=style&index=0&id=5e141cca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e141cca",
  null
  
)

export default component.exports